// Client-side gate for the payroll module.
//
// The payroll pages are specific to this company, so they are switchable in one
// place: set REACT_APP_PAYROLL_ENABLED=false and the route and the admin tile
// both disappear. The server has its own matching switch
// (PAYROLL_MODULE_ENABLED) - turn both off together, since a hidden page whose
// API still answers is not really gated.
//
// Defaults to on, so an existing deployment that sets neither is unchanged.
export const PAYROLL_ENABLED =
  String(process.env.REACT_APP_PAYROLL_ENABLED ?? 'true').trim().toLowerCase() !== 'false';

// The permission that guards every payroll surface. Named once here so the
// route, the tile and the page cannot drift apart.
export const PAYROLL_PERMISSION = 'manage_payroll';
